import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { cn } from '../../../utils/helper';

/**
 * The action beside a primary one — cancel, back, reset, or a second choice.
 *
 * Styling is `.btn-secondary` (utils/tailwind-buttons.js). With no `onClick`
 * it goes back a step, which is what the form screens rely on.
 */
export default function SecondaryButton({
  btnText,
  text,
  children,
  btnType,
  type,
  disabled,
  className,
  onClick,
  ...rest
}) {
  const navigate = useNavigate();
  return (
    <button
      {...rest}
      type={type || btnType}
      disabled={disabled}
      className={cn('btn-secondary', className)}
      onClick={onClick || (() => navigate(-1))}
    >
      {children ?? btnText ?? text}
    </button>
  );
}

SecondaryButton.propTypes = {
  btnText: PropTypes.node,
  text: PropTypes.node,
  children: PropTypes.node,
  btnType: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func
};
